// ** Utils & Helpers
import DateTime from "./datetime";

// #####################################################

export const generateMetaDescriptionOnUserProfile = (user, t) => {
	// ** 1. OPIS UŻYTKOWNIKA
	const userDescriptionCut = user.description.cut;

	const metaDescUserDescription = userDescriptionCut
		? `${userDescriptionCut}${
				userDescriptionCut.trim().endsWith(".") ? " " : ". "
		  }`
		: "";

	// ** 2. SZUKAM

	// ** 2.1 Szukam - Osób Płci
	const userSearchSexProcessed = user.search.search_sex.length
		? user.search.search_sex.map((sex) =>
				t(`common:sexOptions.${sex}`).toLowerCase()
		  )
		: "";

	const metaDescSearchSex = userSearchSexProcessed
		? `${t(`userProfile:looking`)}: ${userSearchSexProcessed.join(", ")}. `
		: "";

	// ** 2.2 Szukam - W celu
	const metaDescSearchPurposeArray = user.search.search_for.map(
		(searchForItem) =>
			t(`filtersAndSelectors:purpose.${searchForItem}`).toLowerCase()
	);

	const metaDescSearchPurpose = metaDescSearchPurposeArray.length
		? `${t("userProfile:purpose")}: ${metaDescSearchPurposeArray.join(
				", "
		  )}. `
		: "";

	// ** 2.3 Szukam - W wieku
	const metaDescSearchAgeObject = user.search.search_age;

	const metaDescSearchAgeFrom = metaDescSearchAgeObject.from
		? `${t("common:from")} ${metaDescSearchAgeObject.from} `
		: "";

	const metaDescSearchAgeTo = metaDescSearchAgeObject.to
		? `${t("common:to")} ${metaDescSearchAgeObject.to}`
		: "";

	const metaDescSearchAge =
		user.search.search_age.from || user.search.search_age.to
			? `${t(
					"userProfile:aged"
			  )}: ${metaDescSearchAgeFrom}${metaDescSearchAgeTo} ${t(
					"common:years"
			  )}. `
			: "";

	// ** 3. DANE

	// ** 3.1 Dane - Imię
	const userNames =
		user?.partners?.name
			?.filter((item) => item !== null)
			.join(` ${t("common:and")} `) || "";

	const metaDescUserName = userNames.length
		? `${t("userProfile:name")}: ${userNames}. `
		: "";

	// ** 3.2 Dane - Język
	const userLanguages = user?.languages?.map((language) =>
		t(`languages:${language}`).toLowerCase()
	);

	const metaDescUserLanguages = userLanguages.length
		? `${t("filtersAndSelectors:languageLabel")}: ${userLanguages.join(
				", "
		  )}. `
		: "";

	// ** 3.3 Dane - Wzrost
	const userHeights =
		user?.partners?.height
			?.filter((item) => item !== null)
			.join(` ${t("common:and")} `) || "";

	const metaDescUserHeights = userHeights.length
		? `${t("filtersAndSelectors:height")}: ${userHeights} cm. `
		: "";

	// ** 3.4 Dane - Sylwetka
	const userFigures =
		user?.partners?.figure
			?.filter((item) => item !== null)
			.map((item) => t(`filtersAndSelectors:figure.${item}`))
			.join(` ${t("common:and")} `)
			.toLowerCase() || "";

	const metaDescUserFigures = userFigures.length
		? `${t("filtersAndSelectors:figureLabel")}: ${userFigures}. `
		: "";

	// ** 3.5 Dane - Znak zodiaku
	const userZodiacs =
		user?.partners?.zodiak
			?.filter((item) => item !== null)
			.map((item) => t(`filtersAndSelectors:zodiac.${item}`))
			.join(` ${t("common:and")} `)
			.toLowerCase() || "";

	const metaDescUserZodiacs = userZodiacs.length
		? `${t("filtersAndSelectors:zodiacLabel")}: ${userZodiacs}. `
		: "";

	// ** 3.6 Dane - Włosy
	const userHairs =
		user?.partners?.hair
			?.filter((item) => item !== null)
			.map((item) => t(`filtersAndSelectors:hair.${item}`))
			.join(` ${t("common:and")} `)
			.toLowerCase() || "";

	const metaDescUserHairs = userHairs.length
		? `${t("filtersAndSelectors:hairLabel")}: ${userHairs}. `
		: "";

	// ** 3.7 Dane - Relacja
	const userRelationship = Number.isInteger(user.relationship)
		? t(
				`filtersAndSelectors:relationship.${user.relationship}`
		  ).toLowerCase()
		: "";

	const metaDescUserRelationship = userRelationship
		? `${t("filtersAndSelectors:relationshipLabel")}: ${userRelationship}. `
		: "";

	// ** 3.8 Dane - Dzieci
	const userKids = Number.isInteger(user.kids)
		? t(`filtersAndSelectors:kids.${user.kids}`).toLowerCase()
		: "";

	const metaDescUserKids = userKids
		? `${t("filtersAndSelectors:kidsLabel")}: ${userKids}. `
		: "";

	// ** 3.9 Dane - Alkohol
	const userAlko =
		user?.partners?.alko
			?.filter((item) => item !== null)
			.map((item) => t(`filtersAndSelectors:drinking.${item}`))
			.join(` ${t("common:and")} `) || "";

	const metaDescUserAlko = userAlko
		? `${t("filtersAndSelectors:drinkingLabel")}: ${userAlko}. `
		: "";

	// ** 3.10 Dane - Palenie
	const userSmoke =
		user?.partners?.smoke
			?.filter((item) => item !== null)
			.map((item) => t(`filtersAndSelectors:smoking.${item}`))
			.join(` ${t("common:and")} `) || "";

	const metaDescUserSmoke = userSmoke
		? `${t("filtersAndSelectors:smokingLabel")}: ${userSmoke}. `
		: "";

	// ** 3.11 Dane - Wykształcenie
	const userEducation =
		user?.partners?.education
			?.filter((item) => item !== null)
			.map((item) => t(`filtersAndSelectors:education.${item}`))
			.join(` ${t("common:and")} `) || "";

	const metaDescUserEducation = userEducation
		? `${t("filtersAndSelectors:educationLabel")}: ${userEducation}. `
		: "";

	// ** 4. PREFERENCJE
	const metaDescPreferencesArray = user.preferences.map((preference) =>
		t(`filtersAndSelectors:preferences.${preference}`).toLowerCase()
	);

	const metaDescPreferences = metaDescPreferencesArray.length
		? `${t(
				"filtersAndSelectors:preferencesLabel"
		  )}: ${metaDescPreferencesArray.join(", ")}. `
		: "";

	// ** 5. W SERWISIE OD
	const date = Number.isInteger(user.create)
		? new Date(user.create * 1000).toISOString()
		: user.create;

	const dt = new DateTime(date);

	const [datePart] = dt.format("DD.MM.YYYY HH:mm").split(" ");

	const metaDescCreatedAt = user.create
		? `${t("common:accountSince")}: ${datePart}.`
		: "";

	// ** GENEROWANIE META DESCRIPTION
	const maxLength = 155;
	const metaDescArray = [
		metaDescUserDescription,
		metaDescSearchSex,
		metaDescSearchPurpose,
		metaDescSearchAge,
		metaDescPreferences,
		metaDescUserName,
		metaDescUserLanguages,
		metaDescUserHeights,
		metaDescUserFigures,
		metaDescUserZodiacs,
		metaDescUserHairs,
		metaDescUserRelationship,
		metaDescUserKids,
		metaDescUserAlko,
		metaDescUserSmoke,
		metaDescUserEducation,
		metaDescCreatedAt,
	];

	let metaDesc = metaDescArray.join("");

	if (metaDesc.length > maxLength) {
		const trimmedDesc = metaDesc.substring(0, maxLength - 3).trim();
		metaDesc = trimmedDesc.endsWith(".")
			? trimmedDesc.slice(0, -1) + "..."
			: trimmedDesc + "...";
	}

	return metaDesc;
};

// #####################################################
